var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnowflake01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0622 8.5L5.93782 15.5M18.0622 8.5L19.1603 4.40192M18.0622 8.5L22.1603 9.59808M5.93782 15.5L1.83974 14.4019M5.93782 15.5L4.83974 19.5981M18.0621 15.4999L5.93774 8.49986M18.0621 15.4999L22.1603 14.4018M18.0621 15.4999L19.1603 19.598M5.93774 8.49986L4.83989 4.40203M5.93774 8.49986L1.83989 9.59819M12 5L12 19M12 5L9 2M12 5L15 2M12 19L9 22M12 19L15 22",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake01);
export default __webpack_public_path__ + "static/media/snowflake-01.903b3904dfa4c55ba7dc1b692928fe21.svg";
export { ForwardRef as ReactComponent };